<template>
  <div>
    <RequestModal v-if="showRequestModal" v-on:closeModal="showRequestModal = false"/>
    <div style="background-color: #062648">
      <Nav />
    </div>
    <section class="py-4 bg-white px-6 md:px-20 md:py-10">
      <div class="imgcont" v-bind:style="{ backgroundImage: 'url(' + baseURL + '/insights/' + article.picture + ')' }"></div>
      <div class="mt-6 lg:flex items-start">
        <ul class="lg:mr-3 list" >
          <li class="font-semibold">Share</li>
          <li class="mt-4">
            <ShareNetwork
              network="facebook"
              :url="`${siteURL}news/view/${$route.params.id}`"
              :title="article.title"
            >
              <img src="../assets/img/Icon awesome-facebook.svg" alt="" class="cursor-pointer" style="width: 20px">
            </ShareNetwork>
          </li>
          <li class="lg:mt-4">
            <ShareNetwork
              network="twitter"
              :url="`${siteURL}news/view/${$route.params.id}`"
              :title="article.title"
            >
              <img src="../assets/img/Icon awesome-twitter.svg" alt="" class="mr-4" style="width: 20px">
            </ShareNetwork>
          </li>
          <li class="lg:mt-4">
            <ShareNetwork
              network="linkedin"
              :url="`${siteURL}news/view/${$route.params.id}`"
              :title="article.title"
            >
              <img src="../assets/img/Icon awesome-linkedin-in.svg" alt="" class="mr-4" style="width: 20px">
            </ShareNetwork>
          </li>
        </ul>
        <div class="mt-4 lg:mt-0 w-full lg:ml-3">
          <h3 class="text-2xl lg:text-4xl font-bold blue">{{article.title}}</h3>
          <div class="mt-6" v-html="article.content"></div>
          <div class="imgcont2 mt-8"></div>
        </div>
      </div>
    </section>
    <News />
    <Footer v-on:showRequest="showRequestModal = true"/>
  </div>
</template>

<script>
import RequestModal from "@/components/RequestModal"
import Nav from "@/components/Nav"
import Footer from "@/components/Footer"
import News from "@/components/News"
import axios from 'axios'
import baseURL from '@/main'
export default {
  components:{
    Nav, Footer, RequestModal, News
  },
  data(){
    return {
      showRequestModal : false,
      article: {},
      baseURL: baseURL,
      siteURL: "https://etranzact.com/"
    }
  },
  methods:{
    
  },
  created(){
    this.$store.commit('startLoading');
    axios.get(`${baseURL}/api/news/view/${this.$route.params.id}`)
    .then(res=>{
      this.article = res.data.result[0]
      console.log(this.article)
      this.$store.commit('stopLoading');
    })
    .catch(err=>{
      console.log(err)
      this.$store.commit('stopLoading');
    })
  }
}
</script>

<style scoped>
/* Modal Styling */
  .l-modal{
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0, 0.3);
  }
  .l-modal::-webkit-scrollbar{
    width: 0
  }
  .loading-modal{
    min-height: 350px; 
  }
  /* Modal Styling */

.blue{
  color: var(--bluetext)
}
.list{
  min-width: 20px
}
.imgcont{
  /* border: 1px solid black; */
  width: 100%;
  min-height: 500px;
  background-repeat: no-repeat;
  background-size: cover;
}
.imgcont2{
  /* border:1px solid black; */
  width: 50%;
  min-height: 200px;
  background-image: url('../assets/img/article/pexels-cottonbro-4507272.png');
  background-repeat: no-repeat;
  background-size: cover;
}

@media only screen and (min-width: 768px){
  
  .imgcont{
    min-height: 600px
  }
  .imgcont2{
    min-height: 300px;
    width: 30%
  }
  
}

</style>